/**
 * Sidebar - Portal-specific wrapper for shared SettingsSidebar
 * 
 * Uses the shared @sophy/shared-ui SettingsSidebar component
 * with portal/patient-specific menu configuration.
 */
import React, { useContext } from "react";
import { SettingsSidebar } from "@sophy/shared-ui";
import { BrandingContext } from "@shared/branding/BrandingContext";

export default function Sidebar({ title, contentdisplay }) {
  const { isBrandingCustomer } = useContext(BrandingContext);

  // Portal-specific menu items (fewer than therapist)
  const menuItems = [
    { to: "/preferences/profile", labelKey: "others.profile" },
    { to: "/preferences/notifications", labelKey: "others.notifications" },
    { to: "/preferences/version", labelKey: "others.version" },
    // Only show "About sophyapp" without a brand of its own (domain or tenant)
    {
      to: "/preferences/about",
      labelKey: "others.about-sop",
      show: !isBrandingCustomer,
    },
    {
      labelKey: "others.help",
      external: true,
      href: "https://hoferdigital.atlassian.net/wiki/spaces/SS/pages/2949447681/Wiki+f+r+Patienten+Athleten+und+Klienten",
    },
  ];

  return (
    <SettingsSidebar
      title={title}
      menuItems={menuItems}
      backLinkKey="settings.backlink"
    >
      {contentdisplay}
    </SettingsSidebar>
  );
}
